import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Typography } from '@mui/material';
import { PaginatedResponse } from '../../interfaces/PaginatedResponse';

import { Pagination } from '../../interfaces/Pagination';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { BoynerOrder } from '../../interfaces/Boyner/BoynerOrder';
import {
  BoynerOrderFilter,
  getDefaultBoynerOrderFilter,
} from '../../interfaces/Boyner/BoynerOrderFilter';
import { getBoynerOrders } from '../../api/Boyner';
import { BoynerOrdersTable } from './BoynerOrdersTable/BoynerOrdersTable';

export const BoynerOrdersPage = () => {
  const [orders, setOrders] = useState<PaginatedResponse<BoynerOrder>>({
    data: [],
    totalCount: 0,
  });
  const [filter, setFilter] = useState(getDefaultBoynerOrderFilter());
  const [loading, setLoading] = useState(false);

  const refreshOrders = (filters?: BoynerOrderFilter) => {
    setLoading(true);
    getBoynerOrders(filters ?? filter)
      .then((res) => setOrders(res))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshOrders();
  }, []);

  const handlePagination = (p: Pagination) => {
    const newFilter = { ...filter, pagination: p };

    setFilter(newFilter);
    refreshOrders(newFilter);
  };

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Waiting open={loading} />

      <Typography variant='h5' sx={{ ...sharedStyles.pageTitle }}>
        Boyner Siparişleri
      </Typography>

      <BoynerOrdersTable
        orders={orders.data}
        totalCount={orders.totalCount}
        pagination={filter.pagination}
        onPagination={handlePagination}
      />
    </Box>
  );
};
